const SPRING_FREQUENCY = 30;

export function stepCursorSpring(
  position: number,
  target: number,
  velocity: number,
  deltaSeconds: number,
) {
  const error = position - target;
  const adjustment = velocity + SPRING_FREQUENCY * error;
  const decay = Math.exp(-SPRING_FREQUENCY * deltaSeconds);

  return {
    position: target + (error + adjustment * deltaSeconds) * decay,
    velocity:
      (velocity - SPRING_FREQUENCY * adjustment * deltaSeconds) * decay,
  };
}
